import { render, staticRenderFns } from "./SerieCard2.vue?vue&type=template&id=6eafd260&scoped=true&"
import script from "./SerieCard2.vue?vue&type=script&lang=js&"
export * from "./SerieCard2.vue?vue&type=script&lang=js&"
import style0 from "./SerieCard2.vue?vue&type=style&index=0&id=6eafd260&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eafd260",
  null
  
)

export default component.exports